// AdminWidgetsSpec.sales.js — TM/영업 그룹 위젯 spec (2026-06-08 회사별 분리)
//
// 회사 무관 (2종):
//   admin_quotes_today     : PINE 전용 견적
//   admin_reservation_today : PINE 전용 예약
//
// 회사별 (PINE/DOT/LNJ 각각 — .sales-companies.js 에서 fan-out):
//   admin_tm_{cc} / admin_cancel_{cc} / admin_sales_{cc}

import React from 'react';
import {
  Receipt, Plane,
} from 'lucide-react';
import { formatCompactKrw, WIDTHS } from './widgetFormat';
import { SALES_COMPANY_SPECS } from './AdminWidgetsSpec.sales-companies';

const fmt = (n) => Number(n || 0).toLocaleString();

// 오늘 견적 (PINE 전용)
function renderQuotesToday(d) {
  const count = Number(d?.count || 0);
  return (
    <span className="inline-flex items-baseline gap-1">
      <span className="text-3xl font-black tabular-nums leading-none text-indigo-700 dark:text-indigo-300">{fmt(count)}</span>
      <span className="text-[11px] font-semibold text-[var(--text-sub)]">건</span>
    </span>
  );
}

// 오늘 예약 (PINE 전용) — "9건(2, 6, 1)" 형식 + 금액
function renderReservationToday(d) {
  if (!d) return '-';
  const total = Number(d.total || 0);
  const cr = Number(d.createCount || 0);
  const up = Number(d.updateCount || 0);
  const ca = Number(d.cancelCount || 0);
  const revenue = Number(d.todayRevenue || 0);
  return (
    <span className="flex flex-col items-end gap-1">
      <span className="inline-flex items-baseline gap-1">
        <span className="text-3xl font-black tabular-nums leading-none text-blue-700 dark:text-blue-300">{fmt(total)}</span>
        <span className="text-[11px] font-semibold text-[var(--text-sub)]">건</span>
        <span className="text-[10px] text-[var(--text-sub)] font-semibold tabular-nums whitespace-nowrap ml-1">({fmt(cr)}, {fmt(up)}, {fmt(ca)})</span>
      </span>
      <span className="text-[11px] text-[var(--text-sub)] font-semibold tabular-nums">{formatCompactKrw(revenue)}</span>
    </span>
  );
}

export const SALES_SPECS = {
  admin_quotes_today: {
    Icon: Receipt, label: '오늘 견적', width: WIDTHS.NARROW, accent: 'indigo', size: 'S',
    render: renderQuotesToday,
    watermarkIcon: Receipt,
  },
  admin_reservation_today: {
    Icon: Plane, label: '오늘 예약', width: WIDTHS.WIDE, accent: 'blue', size: 'S',
    render: renderReservationToday,
    watermarkIcon: Plane,
  },
  ...SALES_COMPANY_SPECS,
};
